import React from 'react';

export default function Resume() {
    return (
        <>
            <div className="subheadings resume">
                <h1>Resume</h1>
                <div className="resume-latest">
                    <a href='/nayaab_phansopkar_resume.pdf'>
                        Download PDF
                    </a>
                </div>
            </div>
        </>
    )
}
